import { render, staticRenderFns } from "./UserProfileAvatar.vue?vue&type=template&id=5ab3984a&"
import script from "./UserProfileAvatar.vue?vue&type=script&lang=js&"
export * from "./UserProfileAvatar.vue?vue&type=script&lang=js&"
import style0 from "./UserProfileAvatar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports